export default __webpack_public_path__ + "static/media/logo.14cf83b3.png";